import { Col, Row, Skeleton } from "antd";
import React from "react";



const SkeletonCardPlaceholder = ({ isLoading = false }) => {
  if (!isLoading) return null;

  return (
    <Row gutter={16}>
      <Col span={4}>
        <div className="skeleton-image-animated">
          <Skeleton.Image active />
        </div>
      </Col>
      <Col span={20}>
        <Skeleton active />
      </Col>
    </Row>
  );
};

export default SkeletonCardPlaceholder;
